import buyToken1 from '../../../assets/svgs/buy_token_1.svg';
import buyToken2 from '../../../assets/svgs/buy_token_2.svg';
import buyToken3 from '../../../assets/svgs/buy_token_3.svg';
// import buyToken4 from '../../../assets/svgs/football_american.svg';
// import buyToken4 from '../../../assets/svgs/buy_token_4.svg';
import { APP_NAME_SHORT } from '../../../lib/constants/globalConstant';

const tokensData = [
    {
        id: 1,
        heading: "Be Part of Every Play",
        description: `When action happens in your zone, your fandom becomes interactive, competitive, and rewarding.`,
        image: buyToken1,
    },
    {
        id: 2,
        heading: "Claim Your Place on the Field",
        description: "Digital field collectibles give fans a persistent connection to the game and the program they support.",
        image: buyToken2,
    },
    {
        id: 3,
        heading: "Unlock Exclusive Fan Experiences",
        description: "Access rewards, collectibles, game-day experiences, giveaways, and recognition within the fan community.",
        image: buyToken3,
    },
    // {
    //     id: 4,
    //     heading: "Trade and Grow Your Collection",
    //     description: "Every Game NFT is a piece of sports history that you can trade, collect, or showcase. Build your ultimate collection.",
    //     image: buyToken4,
    // },
]

export default tokensData